import React from "react";

export const Tag = (props) => {

  const {
    label = "",
    active = false,
    current = false,
    edit = false,
    onClick = () => {}
  } = props;

  return (
    <span
      style={{"cursor" : (edit) ? "pointer" : "default"}}
      className={`ui-tag ${active ? "active" : ""} ${
        current && edit ? "current" : ""
      }`}
      onClick={onClick}
    >
      {label}
    </span>
  );
};
